export default __webpack_public_path__ + "static/media/cove fluted panel.4313035a.png";